import { CaptchaApi, OrdersApi, PaymentPagesApi, UsersApi } from '@p2p/services';
import { configureStore } from '@reduxjs/toolkit';

import { baseApi } from './baseApi';
import { errorCatcherMiddleware } from './middleware';

export const store = configureStore({
  reducer: {
    [UsersApi.reducerPath]: UsersApi.reducer,
    [CaptchaApi.reducerPath]: CaptchaApi.reducer,
    [PaymentPagesApi.reducerPath]: PaymentPagesApi.reducer,
    [OrdersApi.reducerPath]: OrdersApi.reducer,
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware()
      .concat(errorCatcherMiddleware)
      .concat(UsersApi.middleware)
      .concat(CaptchaApi.middleware)
      .concat(PaymentPagesApi.middleware)
      .concat(OrdersApi.middleware)
      .concat(baseApi.middleware);
  },
});
